import $ from 'jquery';
const faq = {
    init: () => {
        const faqCategoriesLinks = document.querySelectorAll('.js-faq-category-link');
        const categoriesMenu = document.querySelector('.faq__categories-menu');
        const categoriesSections = document.querySelectorAll('.faq-category');
        const backButtons = document.querySelectorAll('.js-back-faq-category');
        faqCategoriesLinks.forEach(link => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                const linkTarget = e.currentTarget.href;
                const targetSectionId = linkTarget.split('#')[1];
                const targetSection = document.getElementById(targetSectionId);
                const visibleSection = $('.faq-category:visible');
                $(e.currentTarget).addClass('active');
                setTimeout(() => {
                    $('.faq').addClass('category-open');
                    $(categoriesMenu).css('display', 'none');
                    if (visibleSection.length > 0) {
                        visibleSection.fadeOut(function () {
                            $(targetSection).fadeIn();
                        })
                    } else {
                        $(targetSection).fadeIn();
                    }
                }, 300)
            })
        });
        backButtons.forEach(button => {
            button.addEventListener('click', () => {
                $('.faq-category:visible').css('display', 'none');
                $(categoriesMenu).fadeIn();
                $('.faq').removeClass('category-open');
                $(faqCategoriesLinks).removeClass('active');
            })
        })
    }
}
export default faq;